import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Logo Component
 * Displays the application logo image with different sizes
 * No text - the logo image contains all necessary branding
 */
const Logo = ({ 
  src,
  alt = 'PoultryPro360 Logo',
  size = 'md', 
  className = '',
  imgClassName = ''
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageSrc, setImageSrc] = useState(src);

  // Reset error state when src changes
  useEffect(() => {
    setImageSrc(src);
    setImageError(false);
  }, [src]);

  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8', 
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-56 h-28',
    '2xl': 'w-20 h-20',
    '3xl': 'w-24 h-24',
  };

  const currentSize = sizeClasses[size] || sizeClasses.md;

  // If no src provided, don't show anything
  if (!imageSrc) {
    return null;
  }

  // If image failed to load, don't show anything
  if (imageError) {
    return null;
  }

  return (
    <div className={`flex items-center justify-center ${currentSize} ${className}`}>
      <img 
        src={imageSrc} 
        alt={alt} 
        className={`w-full h-full object-contain ${imgClassName}`}
        onError={(e) => {
          setImageError(true);
        }}
      />
    </div>
  );
};

Logo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl']),
  className: PropTypes.string,
  imgClassName: PropTypes.string,
};

export default Logo;